import React from 'react';
import Page from "./page";
import { Reveal, d } from "./motion";
import ReactGA from "react-ga4";
ReactGA.send(window.location.pathname);


export const MFT_FEATURES = [
    {
        id: 1,
        text: 'Vehicle Financing',
        url: 'https://www.myfinance.tools/vehicle-finance',
        description: "What to know how much you'll be paying a month for that new car you want to buy?"
    },
    {
        id: 2,
        text: 'Mortage or Bond',
        url: 'https://www.myfinance.tools/mortgage',
        description: "Find out how much you can expect to pay on your bond or mortgage per month, and how much you can expect to pay in total"
    },
    {
        id: 3,
        text: 'Income Tax ',
        url: 'https://www.myfinance.tools/income-tax',
        description: "Not sure how much tax you're supposed to be paying? find out here"
    },
    {
        id: 4,
        text: 'Retirement ',
        url: 'https://www.myfinance.tools/retirement',
        description: " Find out how much you need to put away a month in order to retire comfortably"
    },
    {
        id: 5,
        text: 'Interest ',
        url: 'https://www.myfinance.tools/interest',
        description: "  Calculate how much interest you will be paying on your next loan"
    },
    {
        id: 6,
        text: 'Amortization',
        url: 'https://www.myfinance.tools/amortization',
        description: "Find out the periodic payments amount due on a loan"
    },
];


function MFT() {
    return (
        <Page
            label="Product — My Finance Tools"
            title="My Finance Tools"
            intro="Simple and easy to use financial tools and calculators. Personal finance made easy."
        >
            <div className="rows">
                {MFT_FEATURES.map((feature, i) => (
                    <Reveal key={feature.id} className="row-item">
                        {i > 0 && <div className="rule" style={d(i * 70)} />}
                        <a
                            href={feature.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="grid grid-cols-12 gap-4 py-8 sm:py-10 items-baseline no-underline text-[#e9e7e2]"
                        >
                            <span className="fade mono text-[#7a7873] col-span-2 sm:col-span-1" style={d(100 + i * 70)}>
                                {String(i + 1).padStart(2, '0')}
                            </span>
                            <span className="fade col-span-10 sm:col-span-5 text-2xl sm:text-3xl tracking-tight" style={d(150 + i * 70)}>
                                <span className="row-name">{feature.text.trim()}</span>
                            </span>
                            <span className="fade col-span-10 col-start-3 sm:col-span-6 sm:col-start-auto flex items-baseline justify-between gap-6 text-[#7a7873] leading-relaxed" style={d(200 + i * 70)}>
                                <span>{feature.description.trim()}</span>
                                <span className="row-arrow text-[#e9e7e2]" aria-hidden="true">↗</span>
                            </span>
                        </a>
                    </Reveal>
                ))}
                <Reveal><div className="rule" /></Reveal>
            </div>

            <a
                href="https://www.myfinance.tools/"
                target="_blank"
                rel="noopener noreferrer"
                className="mono mt-14 inline-flex items-center gap-2 text-[#e9e7e2] no-underline underline-draw"
            >
                myfinance.tools <span aria-hidden="true">↗</span>
            </a>
        </Page>
    );
}

export default MFT;
